import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  startDate: [],
  endDate:[]
}

export const dateSlice = createSlice({
  name: 'date',
  initialState,
  reducers: {
    date: (state, action) => {
      let num = action.payload.num;
      state.startDate[num] = action.payload.startDate;
      state.endDate[num] = action.payload.endDate;
  },
},
})
export const {date} = dateSlice.actions

export default dateSlice.reducer